import axios from 'axios';

let BASE_URL = 'https://admin.tongban.hongen.com/api';
if (process.env.NODE_ENV === 'development') {
  BASE_URL = 'http://device.test.hongen.com/api';
}
const SERIES_LIST_URL = `${BASE_URL}/anonymous/talkypen/series`;
const BOOK_LIST_URL = `${BASE_URL}/anonymous/talkypen/books`;
const FIRMWARE_LIST_URL = `${BASE_URL}/anonymous/talkypen/versions`;

function getSeriesList(deviceType) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: SERIES_LIST_URL,
      params: {
        device_type: deviceType,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getBookList(deviceType, seriesName, bookName, pageNumber) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: BOOK_LIST_URL,
      params: {
        device_type: deviceType,
        series_name: seriesName,
        query_name: bookName,
        page_num: pageNumber,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getFirmwareList(deviceType) {
  return new Promise((resolve, reject) => {
    let params = {};
    if (deviceType) {
      params = {
        device_type: deviceType,
      };
    }
    axios({
      method: 'get',
      url: FIRMWARE_LIST_URL,
      params,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  getSeriesList,
  getBookList,
  getFirmwareList,
};
